"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAttributeValueTitle = void 0;
const getAttributeValueTitle = ({ subAttribute, getAttributeName, getAttributeValueName }) => {
    var _a;
    const title = (_a = subAttribute.valueName) !== null && _a !== void 0 ? _a : (subAttribute.valueId
        ? getAttributeValueName(subAttribute.valueId) || null
        : getAttributeName(subAttribute.attributeId) || null);
    return title;
};
exports.getAttributeValueTitle = getAttributeValueTitle;
